module.exports = __webpack_public_path__ + "media/images/coorum_icon_mail-45f5b89dcf9ba3e3995b31c5f3dd40eb.svg";